import APIService from '../APIService';
import { API_HOST, apiEndpoints } from '../../constants/APIConstants';

export function getMitraDetails(id) {
  return new Promise((resolve, reject) => {
    APIService.request(
      {
        method: 'GET',
        url: `${API_HOST}${apiEndpoints.MITRAS}/${id}`,
      },
      (error, data) => {
        if (error) {
          reject(error);
        } else if (data) {
          resolve(data);
        } else {
          resolve(null);
        }
      }
    );
  });
}
export default {};
